import React, { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { ff } from '@atlassian/jira-feature-flagging';
import type { actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef$key } from '@atlassian/jira-relay/src/__generated__/actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef.graphql';
import type { actionSection_servicedeskSettingsVirtualAgentLanding_projectRef$key } from '@atlassian/jira-relay/src/__generated__/actionSection_servicedeskSettingsVirtualAgentLanding_projectRef.graphql';
import { CreateVirtualAgentSection } from './create-virtual-agent-section';
import { EnableAiBanner } from './enable-ai-banner';
import { UpgradeButton } from './upgrade-button';

export const ActionSection: FC<{
	projectRef: actionSection_servicedeskSettingsVirtualAgentLanding_projectRef$key;
	featuresRef: actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef$key;
}> = ({ projectRef, featuresRef }) => {
	const project = useFragment(
		graphql`
			fragment actionSection_servicedeskSettingsVirtualAgentLanding_projectRef on JiraProject {
				...createVirtualAgentSection_servicedeskSettingsVirtualAgentLanding
			}
		`,
		projectRef,
	);

	const features = useFragment(
		graphql`
			fragment actionSection_servicedeskSettingsVirtualAgentLanding_featuresRef on VirtualAgentFeatures
			@argumentDefinitions(checkForAiEnabledFF: { type: "Boolean!" }) {
				isVirtualAgentAvailable
				isAiEnabledInAdminHub @include(if: $checkForAiEnabledFF)
			}
		`,

		featuresRef,
	);

	// if not premium show upgrade button/text
	if (!features?.isVirtualAgentAvailable) {
		return <UpgradeButton />;
	}

	// if Ai is off show activate Ai banner
	if (ff('check-for-ai-enabling-in-get-premium-banner_oxh6r') && !features?.isAiEnabledInAdminHub) {
		return <EnableAiBanner />;
	}

	// otherwise, show section to create virtual service agent
	return <CreateVirtualAgentSection project={project} />;
};
